import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner } from "reactstrap";
import { API_URL } from "../../config";

const UserWalletBalance = () => {
  const [allData, setAllData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_URL + "/api/wallet/getWallet/balance", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          formValue: { currencyName: "", sortOption: -1 },
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status) {
        const BalanceData = data.data?.amount || [];
        setAllData(BalanceData);
        setCurrencies([
          ...new Set(
            BalanceData.map((item) => item.currencyId?.currencySymbol)
          ),
        ]);
        filterData(BalanceData, selectedCurrency, 1);
      } else {
        throw new Error(data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (data, currency, pageNumber) => {
    let filtered = data;
    if (currency) {
      filtered = data.filter(
        (item) => item.currencyId?.currencySymbol === currency
      );
    }

    const total = filtered.length;
    setTotalPages(Math.ceil(total / limit));

    const startIndex = (pageNumber - 1) * limit;
    const paginatedData = filtered.slice(startIndex, startIndex + limit);
    setDisplayData(paginatedData);
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    filterData(allData, selectedCurrency, page);
  }, [allData, selectedCurrency, page]);

  const handleCurrencyChange = (e) => {
    setSelectedCurrency(e.target.value);
    setPage(1);
  };

  const handleDownloadCSV = () => {
    const csvRows = [
      ["User", "Currency", "Balance"],
      ...allData
        .filter(
          (item) =>
            !selectedCurrency ||
            item.currencyId?.currencySymbol === selectedCurrency
        )
        .map((item) => [
          item?.userId?.email || "",
          item?.currencyId?.currencySymbol || "",
          item?.amount || "",
        ]),
    ];
    const csvContent = csvRows.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `wallet_Balance_${selectedCurrency || "all"}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handlePageChange = (direction) => {
    if (direction === "prev" && page > 1) {
      setPage(page - 1);
    } else if (direction === "next" && page < totalPages) {
      setPage(page + 1);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 font-size-18">Wallet Balance</h4>
            </div>
          </Col>
        </Row>
        <div className="d-space-between mb-3 arrow-need">
          <select
            value={selectedCurrency}
            onChange={handleCurrencyChange}
            className="form-control w-auto"
            style={{
              appearance: "auto",
              WebkitAppearance: "auto",
              MozAppearance: "auto",
            }}
          >
            <option value="">All Currencies</option>
            {currencies.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </select>
          <div className="r-g-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={handleDownloadCSV}
            >
              Export CSV
            </button>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                setSelectedCurrency("");
                setPage(1);
                fetchAllData();
              }}
            >
              Refresh
            </button>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-3">
            <Spinner />
          </div>
        ) : error ? (
          <div className="text-danger text-center my-3">{error}</div>
        ) : (
          <>
            <table className="table text-center">
              <thead>
                <tr>
                  <th scope="col">User</th>
                  <th scope="col">Currency</th>
                  <th scope="col">Balance</th>
                </tr>
              </thead>
              <tbody>
                {displayData.length > 0 ? (
                  displayData.map((address) => (
                    <tr key={address?._id}>
                      <td>{address?.userId?.email}</td>
                      <td>{address?.currencyId?.currencySymbol}</td>
                      <td>{address?.amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3">No records found</td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-center align-items-center mt-3">
              <button
                disabled={page === 1}
                onClick={() => handlePageChange("prev")}
                className="btn btn-primary mx-2"
              >
                Prev
              </button>
              <span>
                Page {page} of {totalPages}
              </span>
              <button
                disabled={page === totalPages}
                onClick={() => handlePageChange("next")}
                className="btn btn-primary mx-2"
              >
                Next
              </button>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default UserWalletBalance;
